// dashboard-agent-ia/src/pages/Conditions.js
import React from 'react'
import { Link } from 'react-router-dom'

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 48 }}>
    <h2 style={{ fontSize: 22, fontWeight: 700, color: 'white', marginBottom: 16, paddingBottom: 12, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>{title}</h2>
    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, lineHeight: 1.8 }}>{children}</div>
  </div>
)

export default function Conditions() {
  const BLUE = '#3b82f6'
  return (
    <div style={{ background: 'linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)', minHeight: '100vh', color: 'white', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
      <nav style={{ padding: '0 clamp(16px,4vw,40px)', height: 68, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg,${BLUE},#1d4ed8)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🤖</div>
          <span style={{ fontWeight: 800, fontSize: 18, color: 'white' }}>Agent <span style={{ color: BLUE }}>IA</span> Sénégal</span>
        </Link>
        <Link to="/" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: 14 }}>← Retour</Link>
      </nav>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: 'clamp(40px,6vw,80px) clamp(16px,5vw,40px)' }}>
        <p style={{ color: BLUE, fontSize: 13, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Légal</p>
        <h1 style={{ fontSize: 48, fontWeight: 800, letterSpacing: '-2px', marginBottom: 12 }}>Conditions d'utilisation</h1>
        <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, marginBottom: 60 }}>Dernière mise à jour : 22 avril 2025</p>

        <Section title="1. Présentation du service">
          <p>Agent IA Sénégal est une plateforme SaaS éditée par LeBinaire, entreprise basée à Dakar, Sénégal. Notre service permet aux entreprises de déployer un assistant WhatsApp intelligent propulsé par l'intelligence artificielle.</p>
          <br/>
          <p>Contact : <a href="mailto:lebinaire@gmail.com" style={{ color: BLUE }}>lebinaire@gmail.com</a> — WhatsApp : +221 77 648 00 68</p>
        </Section>

        <Section title="2. Acceptation des conditions">
          <p>En créant un compte et en utilisant Agent IA Sénégal, vous acceptez sans réserve les présentes conditions d'utilisation. Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser notre service.</p>
        </Section>

        <Section title="3. Abonnements et paiements">
          <p><strong style={{ color: 'white' }}>Starter — 15 000 FCFA/mois :</strong> Accès aux modules de base. Réponses texte uniquement. 500 messages/mois.</p>
          <br/>
          <p><strong style={{ color: 'white' }}>Pro — 35 000 FCFA/mois :</strong> Accès à tous les modules avancés. Réponses texte et audio. 2 000 messages/mois.</p>
          <br/>
          <p><strong style={{ color: 'white' }}>Premium — 65 000 FCFA/mois :</strong> Accès illimité à tous les modules. Texte, audio et images. Messages illimités. Support dédié.</p>
          <br/>
          <p>Les abonnements sont facturés mensuellement et peuvent être résiliés à tout moment. Aucun remboursement pour les mois entamés.</p>
        </Section>

        <Section title="4. Utilisation acceptable">
          <p>Vous vous engagez à utiliser Agent IA Sénégal uniquement à des fins légales et légitimes. Il est interdit d'utiliser notre service pour :</p>
          <ul style={{ marginTop: 12, paddingLeft: 20 }}>
            <li style={{ marginBottom: 8 }}>Envoyer des messages non sollicités (spam)</li>
            <li style={{ marginBottom: 8 }}>Diffuser des contenus illégaux, haineux ou trompeurs</li>
            <li style={{ marginBottom: 8 }}>Usurper l'identité d'une autre personne ou entreprise</li>
            <li style={{ marginBottom: 8 }}>Tenter de contourner les limitations du service</li>
          </ul>
        </Section>

        <Section title="5. Propriété intellectuelle">
          <p>Tous les contenus de la plateforme Agent IA Sénégal (code, design, textes, logos) sont la propriété exclusive de LeBinaire. Toute reproduction sans autorisation est interdite.</p>
          <br/>
          <p>Les contenus que vous configurez (FAQ, modèles, catalogue) restent votre propriété. Vous nous accordez une licence limitée pour les utiliser afin de faire fonctionner le service.</p>
        </Section>

        <Section title="6. Disponibilité du service">
          <p>Nous nous efforçons de maintenir une disponibilité de 99% du service. Cependant, des interruptions peuvent survenir pour maintenance ou raisons techniques. LeBinaire ne saurait être tenu responsable des pertes dues à ces interruptions.</p>
        </Section>

        <Section title="7. Résiliation">
          <p>Vous pouvez supprimer votre compte à tout moment depuis votre tableau de bord. Vos données seront supprimées définitivement dans un délai de 30 jours.</p>
          <br/>
          <p>LeBinaire se réserve le droit de résilier un compte en cas de violation des présentes conditions.</p>
        </Section>

        <Section title="8. Limitation de responsabilité">
          <p>Agent IA Sénégal est fourni "en l'état". LeBinaire ne garantit pas que le service sera exempt d'erreurs. La responsabilité de LeBinaire est limitée au montant payé au cours des 3 derniers mois.</p>
        </Section>

        <Section title="9. Droit applicable">
          <p>Les présentes conditions sont régies par le droit sénégalais. Tout litige sera soumis aux tribunaux compétents de Dakar, Sénégal.</p>
        </Section>
      </div>
      <footer style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: 'clamp(20px,4vw,40px)', textAlign: 'center' }}>
        <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>© 2025 Agent IA Sénégal by LeBinaire · <Link to="/confidentialite" style={{ color: 'rgba(255,255,255,0.3)', textDecoration: 'none' }}>Confidentialité</Link> · <Link to="/contact" style={{ color: 'rgba(255,255,255,0.3)', textDecoration: 'none' }}>Contact</Link></p>
      </footer>
    </div>
  )
}
